import { MessageInterface } from './message-interface.model';

interface FileMessageData {
  author: string;
  authorId: number;
  createDate: string;
  createrId: number;
  discussionId: number;
  fullPath: string;
  id: number;
  isAuthor: boolean;
  messageId: number;
  mimeType: string;
  name: string;
  originalName: string;
  path: string;
  size: number;
  updateDate: string;
  updaterId: number;
}

export class FileMessage implements MessageInterface {
    public author: string;
    public authorId: number;
    public createDate: string;
    public createrId: number;
    public discussionId: number;
    public fullPath: string;
    public id: number;
    public isAuthor: boolean;
    public messageId: number;
    public mimeType: string;
    public name: string;
    public originalName: string;
    public path: string;
    public size: number;
    public updateDate: string;
    public updaterId: number;

    public static fromAPI(data: FileMessageData): FileMessage {
      return new FileMessage(data);
    }

    constructor({author, authorId, createDate, createrId, discussionId, fullPath, id, isAuthor, messageId, mimeType, name, originalName, path, size, updateDate, updaterId} : FileMessageData ) {
        this.author = author;
        this.authorId = authorId;
        this.createDate = createDate;
        this.createrId = createrId;
        this.discussionId = discussionId;
        this.fullPath = fullPath;
        this.id = id;
        this.isAuthor = isAuthor;
        this.messageId = messageId;
        this.mimeType = mimeType;
        this.name = name;
        this.originalName = originalName;
        this.path = path;
        this.size = size;
        this.updateDate = updateDate;
        this.updaterId = updaterId;
    }

    public get content(): string {
        return this.originalName;
    }
}
